import { observer } from 'mobx-react';
import * as React from 'react';
import { Button, Modal, Box, Typography, Grid, List, ListItemAvatar, AccordionDetails, AccordionSummary, Avatar, Accordion } from '@mui/material';

import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import ExpandLessIcon from '@mui/icons-material/ExpandLess';

import ImageIcon from '@mui/icons-material/Image';

import ListItem from '@mui/material/ListItem';
import ListItemButton from '@mui/material/ListItemButton';
import ListItemText from '@mui/material/ListItemText';
import { useDialogState } from 'hooks/useDialogState';
import LockIcon from '@mui/icons-material/Lock';
import LockOpenIcon from '@mui/icons-material/LockOpen';
import emailIcon from '../../../assets/image/sms.png';
import bluePin from '../../../assets/image/bluePin.png';
import redPin from '../../../assets/image/redPin.png';
import BasicImage from 'pages/MyPage/component/BasicImage';
import { AssessModel } from 'domains/models/AssessModel';
import styled from '@emotion/styled';
import { TaskModel } from 'domains/models/TaskModel';
import moment from 'moment';
import TimelinePageStore from '../store/TimelinePageStore';

const style = {
  position: 'absolute' as 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  bgcolor: 'background.paper',
  boxShadow: 'none',
  borderRadius: '15px',
  paddingTop: '40px',
  paddingBottom: '20px',
  minWidth: '335px',
};

const StyledAccordion = styled(Accordion)(({ theme }) => ({
  '&::before': {
    display: 'none',
  },
  '& .MuiButtonBase-root .MuiAccordionSummary-root .Mui-expanded': {
    minHeight: '42px',
    boxShadow: 'nonoe',
  },
  '& .MuiAccordionSummary-content': {
    margin: '0px',
  },
  '& .MuiAccordionDetails-root': {
    padding: 0,
  },
}));

interface Props {
  pageStore: TimelinePageStore;
}

function CommentViewModal(props: Props) {
  const { pageStore } = props;
  const [expanded, setExpanded] = React.useState<string | false>(false);
  const [flag, setFlag] = React.useState<boolean>(true);

  const handleClickPanel = (panel: string) => {
    setFlag(!flag);
    setExpanded(flag ? panel : false);
  };

  const handleClose = () => {
    setFlag(true);
    pageStore.setIsOpenModal(false);
  };

  const renderLockIcon = (child: AssessModel) => {
    if (child.subtype === 'VISIBLE') {
      return <LockOpenIcon />;
    } else {
      return <LockIcon />;
    }
  };
  const renderPinIcon = (child: AssessModel) => {
    if (child.userData?.like === 'true') {
      return <img src={bluePin} alt='bluePin' />;
    } else if (child.userData?.like === 'false') {
      return <img src={redPin} alt='redPin' />;
    }
  };

  const renderPrimary = (task: TaskModel) => {
    if (task.subtype === 'CHAT') {
      if (task.userData?.body?.contentType === 'html') {
        let content = task.userData?.body?.content;

        content = content
          ?.split('<')
          .filter((el: any) => !el.startsWith('img'))
          .filter((el: any) => !el.startsWith('div>&nbsp'))
          ?.join('<');
        return (
          <div>
            <div
              style={{
                maxHeight: '49px',
                fontStyle: 'normal',
                fontWeight: 500,
                fontSize: '16px',
                lineHeight: '16px',
                width: '137px',
                color: '#171918',
                overflow: 'hidden',
                textOverflow: 'ellipsis',
              }}
              dangerouslySetInnerHTML={{
                __html: content as any,
              }}
            ></div>
            <p
              style={{
                fontFamily: 'Pretendard',
                fontStyle: 'normal',
                fontWeight: 400,
                fontSize: '12px',
                lineHeight: '12px',
                color: '#ABABAB',
              }}
            >
              {moment(task.userData.createdDateTime).format('YYYY/MM/DD')}
            </p>
          </div>
        );
      } else {
        let content = task.userData?.body?.content?.split('<')[0];
        return (
          <div
            style={{
              fontStyle: 'normal',
              fontWeight: 500,
              fontSize: '16px',
              lineHeight: '16px',
              color: '#171918',
              overflow: 'hidden',
              textOverflow: 'ellipsis',
            }}
          >
            {content}
            <p
              style={{
                fontFamily: 'Pretendard',
                fontStyle: 'normal',
                fontWeight: 400,
                fontSize: '12px',
                lineHeight: '12px',
                color: '#ABABAB',
              }}
            >
              {moment(task.userData?.createdDateTime).format('YYYY/MM/DD')}
            </p>
          </div>
        );
      }
    } else {
      if (task.userData?.bodyPreview) {
        return (
          <div
            style={{
              fontStyle: 'normal',
              fontWeight: 500,
              fontSize: '16px',
              lineHeight: '16px',
              color: '#171918',
              overflow: 'hidden',
              width: '160px',
              textOverflow: 'ellipsis',
              whiteSpace: 'nowrap',
            }}
          >
            {task.title}
            <p
              style={{
                fontWeight: 400,
                fontSize: '14px',
                lineHeight: '14px',
                color: '#171918',
                width: '160px',
                overflow: 'hidden',
                textOverflow: 'ellipsis',
                whiteSpace: 'nowrap',
              }}
            >
              {task.userData?.bodyPreview}
            </p>
            <p
              style={{
                fontFamily: 'Pretendard',
                fontStyle: 'normal',
                fontWeight: 400,
                fontSize: '12px',
                lineHeight: '12px',
                color: '#ABABAB',
              }}
            >
              {moment(task.userData?.receivedDateTime).format('YYYY/MM/DD')}
            </p>
          </div>
        );
      }
      return (
        <div
          style={{
            fontStyle: 'normal',
            fontWeight: 500,
            fontSize: '16px',
            lineHeight: '16px',
            color: '#171918',
            overflow: 'hidden',
            width: '160px',
            textOverflow: 'ellipsis',
            whiteSpace: 'nowrap',
          }}
        >
          {task.title}
          <p
            style={{
              fontFamily: 'Pretendard',
              fontStyle: 'normal',
              fontWeight: 400,
              fontSize: '12px',
              lineHeight: '12px',
              color: '#ABABAB',
            }}
          >
            {moment(task.userData?.receivedDateTime).format('YYYY/MM/DD')}
          </p>
        </div>
      );
    }
  };

  const renderEmoticion = (children: AssessModel[] | undefined) => {
    return children?.map((child: AssessModel) => {
      return <span key={child.id}>{child.userData?.emoticon ? child.userData?.emoticon : ''}</span>;
    });
  };

  return (
    <Modal open={pageStore.isOpenModal} onClose={handleClose} aria-labelledby='modal-title' aria-describedby='modal-description'>
      <Box sx={style}>
        <Typography
          style={{
            fontFamily: 'Pretendard',
            fontWeight: 500,
            fontSize: '16px',
            lineHeight: '16px',
            textAlign: 'center',
            marginBottom: '12px',
            color: '#212121',
          }}
        >
          Comment View
        </Typography>
        <List>
          <StyledAccordion
            key={pageStore.task.id}
            expanded={expanded === `panel${pageStore.task.id}`}
            style={{
              marginBottom: '14px',
              boxShadow: 'none',
            }}
          >
            <AccordionSummary
              sx={{
                justifyContent: 'normal',
                padding: 0,
                display: 'block',
                position: 'relative',
              }}
            >
              <ListItem>
                <div style={{ cursor: 'pointer' }} onClick={() => handleClickPanel(`panel${pageStore.task.id}`)}>
                  {flag ? (
                    <ExpandMoreIcon
                      style={{
                        position: 'absolute',
                        bottom: '15px',
                        right: '10px',
                      }}
                    />
                  ) : (
                    <ExpandLessIcon
                      style={{
                        position: 'absolute',
                        bottom: '15px',
                        right: '10px',
                      }}
                    />
                  )}
                </div>
                <ListItemAvatar>
                  <Avatar
                    style={{
                      background: '#EBF8F5',
                    }}
                  >
                    <img src={emailIcon} alt='emailIcon' />
                  </Avatar>
                </ListItemAvatar>
                <ListItemText primary={renderPrimary(pageStore.task)} secondary={renderEmoticion(pageStore.task?.children)} />
              </ListItem>
            </AccordionSummary>
            <AccordionDetails>
              {pageStore.task.children?.length !== 0 ? (
                pageStore.task.children?.map((child: AssessModel) => {
                  return (
                    <ListItem key={child.created} style={{}}>
                      {child.user?.userData?.profile ? (
                        <BasicImage
                          src={child.user?.userData?.profile}
                          style={{
                            width: 44,
                            height: 44,
                            borderRadius: '50%',
                            objectFit: 'cover',
                            overflow: 'hidden',
                          }}
                        />
                      ) : (
                        <Avatar>
                          <ImageIcon
                            sx={{
                              borderRadius: '50%',
                              objectFit: 'cover',
                              overflow: 'hidden',
                            }}
                          />
                        </Avatar>
                      )}

                      <ListItemText
                        primary={
                          <span
                            style={{
                              fontFamily: 'Pretendard',
                              fontStyle: 'normal',
                              fontWeight: 600,
                              fontSize: '16px',
                              lineHeight: '16px',
                              color: '#000000',
                            }}
                          >
                            {child.user?.names?.fullname}
                            <span
                              style={{
                                fontFamily: 'Pretendard',
                                fontStyle: 'normal',
                                fontWeight: 500,
                                fontSize: '14px',
                                lineHeight: '14px',
                                color: '#212121',
                                marginLeft: '4px',
                              }}
                            >
                              {child.user?.userData.jobTitle}
                              <span
                                style={{
                                  fontWeight: 400,
                                  fontSize: '12px',
                                  lineHeight: '12px',
                                  color: '#6C6B6F',
                                  marginLeft: '4px',
                                }}
                              >
                                {child.user?.userData.deptName}
                              </span>
                            </span>
                          </span>
                        }
                        secondary={
                          <Typography
                            style={{
                              fontWeight: 400,
                              fontSize: '14px',
                              lineHeight: '14px',
                              color: '#171918',
                              marginTop: '4px',
                              width: '160px',
                              overflow: 'hidden',
                              textOverflow: 'ellipsis',
                              whiteSpace: 'nowrap',
                            }}
                          >
                            {child.title ? child.title : '내용이 없습니다'}
                          </Typography>
                        }
                        style={{
                          margin: 0,
                          marginLeft: '16px',
                        }}
                      />
                      {renderLockIcon(child)}
                      {renderPinIcon(child)}
                    </ListItem>
                  );
                })
              ) : (
                <Typography>코멘트가 없습니다.</Typography>
              )}
            </AccordionDetails>
          </StyledAccordion>
          {/* <ListItem key={0}>
            <ListItemAvatar>
              <Avatar>
                <EmailOutlined />
              </Avatar>
            </ListItemAvatar>
            <ListItemText
              primary={
                pageStore.task?.subtype === "CHAT"
                  ? pageStore.task?.userData?.body?.content
                  : pageStore.task?.title
              }
              secondary={renderEmoticion(pageStore.task?.childrens)}
            />
          </ListItem>
          {pageStore.task?.childrens &&
            pageStore.task?.childrens.map((child: AssessModel) => {
              return <Typography>{child.title}</Typography>;
            })} */}
        </List>
        <Grid container justifyContent={'center'} style={{ padding: '0px 20px' }}>
          <Button
            sx={{
              background: '#2281D0',
              borderRadius: '25px',
              color: '#ffffff',
              fontWeight: 500,
              fontSize: '16px',
              lineHeight: '16px',
              width: '100%',
              padding: '17px 0px',
              boxShadow: 'none',
            }}
            variant='contained'
            onClick={handleClose}
          >
            CLOSE
          </Button>
        </Grid>
      </Box>
    </Modal>
  );
}

export default observer(CommentViewModal);
